import React from 'react'
import { Grid, Heading } from '@chakra-ui/react'
import { StockData } from '../types'
import StatCard from './StatCard'
import { formatCurrency, formatNumber, formatPercent } from '../utils'

interface FinancialsPanelProps {
  data: StockData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const FinancialsPanel: React.FC<FinancialsPanelProps> = ({
  data,
  gridTemplateColumns,
  statCardBg
}) => (
  <>
    <Heading as="h3" fontSize="xl" mb={4}>
      Financials
    </Heading>
    
    <Grid
      gap={4}
      templateColumns={`repeat(${gridTemplateColumns || 1}, 1fr)`}
      width="100%"
    >
      <StatCard
        bg={statCardBg}
        label="Revenue"
        value={formatCurrency(data.financials.revenue)}
        helpText="Annual revenue"
      />
      
      <StatCard
        bg={statCardBg}
        label="Gross Profit"
        value={formatCurrency(data.financials.grossProfit)}
        helpText="Revenue minus cost of goods sold"
      />
      
      <StatCard
        bg={statCardBg}
        label="Operating Income"
        value={formatCurrency(data.financials.operatingIncome)}
        helpText="Profit from business operations"
      />
      
      <StatCard
        bg={statCardBg}
        label="Net Income"
        value={formatCurrency(data.financials.netIncome)}
        helpText="Total earnings after all expenses"
      />
      
      <StatCard
        bg={statCardBg}
        label="Cash Flow"
        value={formatCurrency(data.financials.cashFlow)}
        helpText="Net cash generated"
      />
      
      <StatCard
        bg={statCardBg}
        label="Cash"
        value={formatCurrency(data.financials.cash)}
        helpText="Cash and cash equivalents"
      />
      
      <StatCard
        bg={statCardBg}
        label="Debt"
        value={formatCurrency(data.financials.debt)}
        helpText="Total debt"
      />
      
      <StatCard
        bg={statCardBg}
        label="Assets"
        value={formatCurrency(data.financials.assets)}
        helpText="Total assets"
      />
      
      <StatCard
        bg={statCardBg}
        label="Liabilities"
        value={formatCurrency(data.financials.liabilities)}
        helpText="Total liabilities"
      />
      
      <StatCard
        bg={statCardBg}
        label="Shares Outstanding"
        value={formatNumber(data.financials.sharesOutstanding)}
        helpText="Total shares in circulation"
      />
      
      <StatCard
        bg={statCardBg}
        label="Dividend Yield"
        value={formatPercent(data.dividendYield)}
        helpText="Annual dividend as percentage of share price"
      />
      
      <StatCard
        bg={statCardBg}
        label="Dividend Rate"
        value={formatCurrency(data.dividendRate)}
        helpText="Annual dividend payment per share"
      />
    </Grid>
  </>
)

export default FinancialsPanel
